import dayjs from "dayjs";
import { getCols } from "./getCols";

export type DatesRange = {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
};

export type ParsedDatesRange = {
  startDate: Date;
  endDate: Date;
};

export const getDatesRange = (date: dayjs.Dayjs, zoom: number): DatesRange => {
  const colsOffset = getCols(zoom, date);

  let startDate;
  switch (zoom) {
    case 0:
    case 1:
    case 3:
      startDate = date.startOf('month');
      break;
    case 2:
      startDate = date.subtract(colsOffset, "hours");
      break;
    case 4:
      startDate = date.startOf('year')
      break;
    default:
      startDate = date.startOf('month');
      break;
  }

  let endDate;
  switch (zoom) {
    case 1:
      endDate = date.endOf('month');
      //endDate = date.add(colsOffset, "days");
      break;
    case 2:
      endDate = date.add(colsOffset, "hours");
      break;
    case 0:
    case 3:
      endDate = date.startOf('month').add(colsOffset, "weeks");
      break;
    case 4:
      //endDate = date.startOf('month').add(colsOffset, "month");
      endDate = date.endOf('year');
      break;
    default:
      endDate = date.endOf('month');
      break;
  }
  
  return {
    startDate,
    endDate
  };
};

export const getParsedDatesRange = (date: dayjs.Dayjs, zoom: number): ParsedDatesRange => {
  const dates = getDatesRange(date, zoom);

  return {
    startDate: dates.startDate.toDate(),
    endDate: dates.endDate.toDate()
  };
};
